const serviceByMailStyle = Object.freeze({
  fontStack: 'base',
});

export default serviceByMailStyle;
